import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

const translations = {
    es: {
        nav: {
            product: 'Producto',
            about: 'Sobre Nosotros',
            contact: 'Contacto'
        },
        home: {
            collection: 'COLECCIÓN',
            selectStyle: 'Selecciona tu estilo',
            viewDetails: 'Ver Detalles',
            intro: 'FOIROLA es más que una marca de ropa; es un tributo a la esencia de Fuengirola. Nacida en el corazón de la Costa del Sol, nuestra misión es capturar el espíritu vibrante, la cultura urbana y el estilo de vida único de nuestra ciudad. Cada prenda cuenta una historia, desde las calles del centro hasta el paseo marítimo, fusionando moda contemporánea con identidad local.'
        },
        product: {
            details: 'Detalles',
            acquire: 'Comprar',
            buyNow: 'Realizar Pedido',
            selectSize: 'Selecciona tu talla',
            sizeS: 'S',
            sizeM: 'M',
            sizeL: 'L',
            inStock: 'En stock',
            soldOut: 'Agotado',
            unitsAvailable: '{count} disponibles',
            limited: 'CANTIDADES EXTREMADAMENTE LIMITADAS',
            sizeGuide: 'Guía de Tallas',
            size: 'Talla',
            width: 'Ancho (cm)',
            length: 'Largo (cm)',
            exclusive: 'Rellena el formulario para realizar tu pedido. Te contactaremos para finalizar el pago y envío.',
            orderForm: {
                title: 'Información de Pedido',
                email: 'Correo Electrónico',
                phone: 'Teléfono',
                address: 'Dirección Completa',
                addressPlaceholder: 'Calle, número, piso, código postal, ciudad',
                submit: 'Realizar Pedido',
                submitting: 'Enviando...',
                success: '¡Pedido enviado! Te contactaremos pronto.',
                error: 'Error al enviar el pedido. Inténtalo de nuevo.'
            }
        },
        about: {
            title: 'Nuestra Historia',
            subtitle: 'Tres zumbaos dándole voz al lore de nuestra tierra. Desde una terraza en Fuengirola hasta colaborar con grandes marcas. Esta es nuestra cronología.'
        },
        timeline: {
            jun2024: {
                date: 'Junio 2024',
                title: 'El Origen',
                desc: 'La idea nace entre tres amigos, unas cervezas y una terraza. Hablando de lo increíble que sería tener nuestra propia marca representando nuestra cultura local.'
            },
            jul2024: {
                date: 'Julio 2024',
                title: 'Primeros Pasos',
                desc: 'Búsqueda de contactos y alianzas. Encontramos a un amigo diseñador que creyó en la idea desde el primer momento.'
            },
            sep2024_1: {
                date: 'Septiembre 2024',
                title: 'Investigación y Desarrollo',
                desc: 'Búsqueda de proveedores locales y printshops. Investigación profunda sobre gramajes (180, 200, 230g) y técnicas de impresión (DTF, DTG, Serigrafía) buscando el equilibrio perfecto entre calidad y coste.'
            },
            sep2024_2: {
                date: 'Septiembre 2024',
                title: 'Prototipado',
                desc: 'Iteración de diseños con nuestro amigo ilustrador. Más de 6 bocetos hasta encontrar el resultado perfecto.'
            },
            oct2024_1: {
                date: 'Octubre 2024',
                title: 'Shooting Guerrilla',
                desc: 'Sesiones de fotos con un amigo fotógrafo (@lleno_dezafiros.ph) y modelos improvisadas (amigas que conocimos saliendo) a cambio de cena o cerveza. Pura pasión y cero presupuesto.'
            },
            oct2024_2: {
                date: '25 Octubre 2024',
                title: 'El Lanzamiento',
                desc: 'Presentación oficial con un video de campaña para generar hype. Evento en un pequeño mercado organizado por un amigo dueño de un pub. ¡SOLD OUT esa misma noche!'
            },
            jan2025: {
                date: '25 Enero 2025',
                title: 'Colaboración Jägermeister',
                desc: 'Cuatro meses después, logramos una colaboración con Jägermeister y Loopers Music, patrocinando un evento en The Club, Málaga.'
            },
            year2025: {
                date: '2025',
                title: 'Mentoria y Crecimiento',
                desc: 'Trabajo duro en el nuevo diseño "Navajitas". Ganamos el respeto y la mentoría del fundador de una marca urbana referente en Málaga.'
            },
            dec2025: {
                date: 'Diciembre 2025',
                title: 'Navajitas Release',
                desc: 'Lanzamiento oficial de la nueva colección. Elevando la calidad y manteniendo nuestra esencia.'
            }
        },
        contact: {
            title: 'Contacto',
            subtitle: '¿Tienes alguna pregunta? Escríbenos y te responderemos lo antes posible.',
            name: 'Nombre',
            email: 'Correo Electrónico',
            message: 'Mensaje',
            send: 'Enviar Mensaje',
            sending: 'Enviando...',
            sent: '¡Mensaje enviado!',
            playSnake: 'Jugar Snake'
        },
        snake: {
            score: 'Puntuación',
            gameOver: 'Juego Terminado',
            playAgain: 'Jugar de Nuevo',
            start: 'Presiona para Jugar',
            instructions: 'Usa las flechas para moverte'
        },
        footer: {
            designed: 'Diseñado en Fuengirola.',
            inspired: 'Inspirado por la cultura local.',
            legal: 'Legal',
            terms: 'Términos y Condiciones',
            privacy: 'Política de Privacidad',
            shipping: 'Envíos y Devoluciones',
            social: 'Social',
            rights: 'Todos los derechos reservados.'
        },
        legal: {
            title: 'Legal',
            termsTitle: 'Términos y Condiciones',
            termsText: 'Bienvenido a FOIROLA. Al acceder a nuestro sitio web y realizar una compra, aceptas los siguientes términos y condiciones. Nos reservamos el derecho de modificar estos términos en cualquier momento, por lo que te recomendamos revisarlos periódicamente. El uso continuado de nuestros servicios implica la aceptación de dichos cambios.',
            privacyTitle: 'Política de Privacidad',
            privacyText: 'En FOIROLA, nos tomamos muy en serio tu privacidad. Queremos ser transparentes: NO almacenamos los datos de los compradores ni los revendemos a terceros. Únicamente almacenamos los datos necesarios para procesar el pago y el envío de tu pedido, por razones obvias de logística y facturación. Tus datos están seguros con nosotros.',
            shippingTitle: 'Envíos y Devoluciones',
            shippingText: 'Actualmente, solo realizamos envíos a España (Península). El tiempo estimado de entrega es de entre 5 y 7 días laborables. Una vez realizado el pedido, recibirás un recibo de compra. Cuando tu pedido sea procesado y enviado, recibirás un correo electrónico con el código de seguimiento para que puedas localizar tu paquete en todo momento.'
        }
    },
    en: {
        nav: {
            product: 'Product',
            about: 'About Us',
            contact: 'Contact'
        },
        home: {
            collection: 'COLLECTION',
            selectStyle: 'Select your style',
            viewDetails: 'View Details',
            intro: 'FOIROLA is more than a clothing brand; it is a tribute to the essence of Fuengirola. Born in the heart of the Costa del Sol, our mission is to capture the vibrant spirit, urban culture, and unique lifestyle of our city. Every garment tells a story, from the downtown streets to the promenade, fusing modern fashion with local identity.'
        },
        product: {
            details: 'Details',
            acquire: 'Purchase',
            buyNow: 'Place Order',
            selectSize: 'Select your size',
            sizeS: 'S',
            sizeM: 'M',
            sizeL: 'L',
            inStock: 'In stock',
            soldOut: 'Sold out',
            unitsAvailable: '{count} available',
            limited: 'EXTREMELY LIMITED QUANTITIES',
            sizeGuide: 'Size Guide',
            size: 'Size',
            width: 'Width (cm)',
            length: 'Length (cm)',
            exclusive: 'Fill out the form to place your order. We will contact you to finalize payment and shipping.',
            orderForm: {
                title: 'Order Information',
                email: 'Email',
                phone: 'Phone',
                address: 'Full Address',
                addressPlaceholder: 'Street, number, floor, postal code, city',
                submit: 'Place Order',
                submitting: 'Sending...',
                success: 'Order sent! We will contact you soon.',
                error: 'Error sending order. Please try again.'
            }
        },
        about: {
            title: 'Our Story',
            subtitle: 'Three crazy friends giving voice to our land\'s lore. From a terrace in Fuengirola to collaborating with big brands. This is our timeline.'
        },
        timeline: {
            jun2024: {
                date: 'June 2024',
                title: 'The Origin',
                desc: 'The idea is born between three friends, some beers, and a terrace. Talking about how incredible it would be to have our own brand representing our local culture.'
            },
            jul2024: {
                date: 'July 2024',
                title: 'First Steps',
                desc: 'Searching for contacts and alliances. We found a designer friend who believed in the idea from the very first moment.'
            },
            sep2024_1: {
                date: 'September 2024',
                title: 'Research & Development',
                desc: 'Searching for local suppliers and printshops. Deep research on weights (180, 200, 230g) and printing techniques (DTF, DTG, Screen Printing) seeking the perfect balance between quality and cost.'
            },
            sep2024_2: {
                date: 'September 2024',
                title: 'Prototyping',
                desc: 'Design iteration with our illustrator friend. More than 6 sketches until finding the perfect result.'
            },
            oct2024_1: {
                date: 'October 2024',
                title: 'Guerrilla Shooting',
                desc: 'Photo sessions with a photographer friend and improvised models (friends we met while going out) in exchange for dinner or beer. Pure passion and zero budget.'
            },
            oct2024_2: {
                date: 'October 25, 2024',
                title: 'The Launch',
                desc: 'Official presentation with a campaign video to generate hype. Event in a small market organized by a friend who owns a pub. SOLD OUT that same night!'
            },
            jan2025: {
                date: 'January 25, 2025',
                title: 'Jägermeister Collaboration',
                desc: 'Four months later, we achieved a collaboration with Jägermeister and Loopers Music, sponsoring an event at The Club, Málaga.'
            },
            year2025: {
                date: '2025',
                title: 'Mentorship & Growth',
                desc: 'Hard work on the new "Navajitas" design. We earned the respect and mentorship of the founder of Disaster Street Wear, a benchmark urban brand in Málaga.'
            },
            dec2025: {
                date: 'December 2025',
                title: 'Navajitas Release',
                desc: 'Official launch of the new collection. Elevating quality and maintaining our essence.'
            }
        },
        contact: {
            title: 'Contact',
            subtitle: 'Have any questions? Write to us and we will get back to you as soon as possible.',
            name: 'Name',
            email: 'Email',
            message: 'Message',
            send: 'Send Message',
            sending: 'Sending...',
            sent: 'Message Sent!',
            playSnake: 'Play Snake'
        },
        snake: {
            score: 'Score',
            gameOver: 'Game Over',
            playAgain: 'Play Again',
            start: 'Press to Play',
            instructions: 'Use arrow keys to move'
        },
        footer: {
            designed: 'Designed in Fuengirola.',
            inspired: 'Inspired by local culture.',
            legal: 'Legal',
            terms: 'Terms & Conditions',
            privacy: 'Privacy Policy',
            shipping: 'Shipping & Returns',
            social: 'Social',
            rights: 'All rights reserved.'
        },
        legal: {
            title: 'Legal',
            termsTitle: 'Terms & Conditions',
            termsText: 'Welcome to FOIROLA. By accessing our website and making a purchase, you agree to the following terms and conditions. We reserve the right to modify these terms at any time, so we recommend reviewing them periodically. Continued use of our services implies acceptance of such changes.',
            privacyTitle: 'Privacy Policy',
            privacyText: 'At FOIROLA, we take your privacy very seriously. We want to be transparent: We do NOT store buyer data nor do we resell it to third parties. We only store the data necessary to process the payment and shipment of your order, for obvious logistical and billing reasons. Your data is safe with us.',
            shippingTitle: 'Shipping & Returns',
            shippingText: 'Currently, we only ship to Spain (Peninsula). The estimated delivery time is between 5 and 7 working days. Once the order is placed, you will receive a purchase receipt. When your order is processed and shipped, you will receive an email with the tracking code so you can locate your package at all times.'
        }
    }
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('es');

    const t = (path) => {
        const keys = path.split('.');
        let current = translations[language];
        for (const key of keys) {
            if (current[key] === undefined) return path;
            current = current[key];
        }
        return current;
    };

    const toggleLanguage = () => {
        setLanguage((prev) => (prev === 'es' ? 'en' : 'es'));
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
